import { ArrowUpRight, CalendarCheck, Clock, MapPin, Navigation, Phone } from "lucide-react";
import { CLINIC } from "@/data/clinic";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";

const CARDS = [
    {
        icon: MapPin,
        title: "Clinic Address",
        lines: CLINIC.addressLines,
        action: { label: "View on Google Maps", href: CLINIC.mapsView },
        testId: "contact-address",
    },
    {
        icon: Phone,
        title: "Phone",
        lines: [CLINIC.phoneDisplay, `Open ${CLINIC.hours.short}.`],
        action: { label: "Call Now", href: CLINIC.phoneTel },
        testId: "contact-phone",
    },
    {
        icon: Navigation,
        title: "Location",
        lines: ["Near Vastralaya Mall,", "Nagi Reddy Revenue Colony, Kurnool"],
        action: { label: "Get Directions", href: CLINIC.mapsDirections },
        testId: "contact-location",
    },
    {
        icon: CalendarCheck,
        title: "Consultation",
        lines: ["Request your slot over a", "quick call or WhatsApp message."],
        action: { label: "Request an Appointment", href: CLINIC.whatsapp },
        testId: "contact-consultation",
    },
];

export default function Contact() {
    return (
        <section id="contact" data-testid="contact-section" className="bg-bone py-20 md:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    overline="Contact"
                    title="Visit Agastya Chiro & Ancient Marma Therapy"
                    testId="contact-heading"
                >
                    We are easy to reach in Nagi Reddy Revenue Colony, near Vastralaya Mall, Kurnool.
                    Call, message, or drop in — the door is open.
                </SectionHeading>

                <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {CARDS.map((c, i) => {
                        const external = c.action.href.startsWith("http");
                        return (
                            <Reveal key={c.title} delay={i * 0.07}>
                                <div
                                    data-testid={`${c.testId}-card`}
                                    className="flex h-full flex-col rounded-3xl border border-sand bg-cream p-8 transition-[box-shadow,transform] duration-500 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(28,35,33,0.25)]"
                                >
                                    <span className="inline-flex w-fit rounded-2xl bg-forest/10 p-3 text-forest">
                                        <c.icon className="h-5 w-5" />
                                    </span>
                                    <h3 className="mt-5 font-serif text-2xl font-medium text-ink">{c.title}</h3>
                                    <p className="mt-3 flex-1 text-sm leading-relaxed text-moss">
                                        {c.lines.map((l, j) => (
                                            <span key={j} className="block">
                                                {l}
                                            </span>
                                        ))}
                                    </p>
                                    <a
                                        href={c.action.href}
                                        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        data-testid={`${c.testId}-btn`}
                                        className="mt-6 inline-flex w-fit items-center gap-1.5 rounded-full bg-forest px-5 py-2.5 text-sm font-semibold text-cream transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-forest-deep"
                                    >
                                        {c.action.label}
                                        <ArrowUpRight className="h-4 w-4" />
                                    </a>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>

                <Reveal delay={0.2}>
                    <div
                        data-testid="opening-hours-bar"
                        className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 rounded-2xl border border-sand bg-cream px-8 py-6"
                    >
                        <span className="inline-flex items-center gap-2.5 text-sm font-semibold text-ink">
                            <Clock className="h-5 w-5 text-terracotta" /> Opening Hours
                        </span>
                        <span className="text-sm text-moss">{CLINIC.hours.weekdays}</span>
                        <span className="text-sm text-moss">{CLINIC.hours.sunday}</span>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
